<template>
  <div>
    <Main
      :height="height"
      :loading="loading"
      :tableData="tableData"
      ref="tableMain"
      :isCheckBox="isCheckBox" 
    >
      <Header ref="tableHeader" slot="header" @query="getData" />
    </Main>
  </div>
</template>
<script>
import Main from './main.vue'
import Header from './header.vue'
export default {
  components: { Main, Header },
  props: {
    height: { type: Number, default: 360 },
    changeOrderCode: { type: String, default: '' },
    isCheckBox:{type:Boolean, default:false}
  },
  data() {
    return {
      loading: false,
      tableData: [],
      goodsSpecDetailDialogParams: {
        visible: false,
        title: '',
        disabled: false,
        code: '',
      },
    }
  },
  methods: {
    getData(form) {
      if (!this.changeOrderCode) return
      this.loading = true
      this.$api
        .orderGoodsBatchListApi({
          changeOrderCode: this.changeOrderCode,
          ...form,
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
    },
    getRadioRecord() {
      return this.$refs.tableMain.getRadioRecord()
    },
  },
}
</script>
